import React from "react";

const Header = () => {
  return <h1>All Weather Planet</h1>;
};

export default Header;
